import { render, staticRenderFns } from "./AppBarSearch.vue?vue&type=template&id=52b9f0ed"
import script from "./AppBarSearch.vue?vue&type=script&lang=js"
export * from "./AppBarSearch.vue?vue&type=script&lang=js"
import style0 from "./AppBarSearch.vue?vue&type=style&index=0&id=52b9f0ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports